<template>
  <div class="empadronamiento__intro__main">
    <div class="empadronamiento__intro__main__form">
      <div class="empadronamiento__intro__main__form__header">
        <p>{{ ModelProcedure.UnitFullName }}</p>
      </div>
      <div class="empadronamiento__intro__main__form__container">
        <form @submit.prevent>
          <fieldset>
            <div class="empadronamiento__intro__main__form__container-header">
              <p>NUEVO VECINO: FORMULARIO PARA REGISTRARSE</p>
            </div>
            <p
              v-if="ProcedureInitDescription != undefined"
              class="empadronamiento__form_header_info_text"
              v-html="ProcedureInitDescription.ProcedureInitDescription"
            ></p>
            <div class="base-select loading-animation" v-if="loading"></div>

            <base-select
              v-else
              v-model="ModelProcedure.ContractTypeId"
              placeholder="Tipo de contrato *"
              :options="Enums.ContractType"
              :invalid="$v.ModelProcedure.ContractTypeId.$invalid && submitted"
            />
            <p
              class="empadronamiento__intro__main__form__container__notes"
              v-if="ModelProcedure.ContractTypeId == 1"
            >
              El periodo de alquiler temporal debe ser mayor a 30 días y menor a
              90 días
            </p>
            <p
              class="empadronamiento__intro__main__form__container__notes"
              v-if="ModelProcedure.ContractTypeId == 2"
            >
              El periodo de alquiler permanente debe ser mayor a 90 días
            </p>

            <div class="base-select loading-animation" v-if="loading"></div>
            <base-date-picker
              v-else
              v-model="ModelProcedure.ContractDateFrom"
              :label="'Desde *'"
              :invalid="
                $v.ModelProcedure.ContractDateFrom.$invalid && submitted
              "
            />

            <div class="base-select loading-animation" v-if="loading"></div>
            <base-date-picker
              v-else
              v-model="ModelProcedure.ContractDateTo"
              :label="'Hasta *'"
              :minDate="MinToDate"
              :maxDate="MaxToDate"
              :invalid="
                ($v.ModelProcedure.ContractDateTo.$invalid ||
                  dateToIsInvalid()) &&
                  submitted
              "
            />

            <template v-for="(attach, i) in attachsRent">
              <base-file-upload
                :key="i"
                :keyIndex="i"
                :attach="attach"
                :showTooltipActive="showTooltipActive"
                @changeTooltipActive="showTooltipActive = $event"
                @change="uploadFile"
                @clearUpload="clearFile"
                :modelProp="getAttachModelPropName(attach)"
                :state="ModelProcedure[getAttachModelPropName(attach)]"
                :invalid="getAttachValidator(attach).$invalid && submitted"
                :previewURL="getAttachPreviewURL(attach)"
              />
              <p
                :key="'p' + i.toString()"
                v-if="attach.Code === 'ProcedureAttachment.LocationContract'"
                class="empadronamiento__intro__main__form__container__notes"
              >
                El adjunto debe ser en formato PDF, conteniendo todas las hojas
                del contrato y contener las firmas de ambas partes.
              </p>
            </template>
          </fieldset>
        </form>

        <div class="empadronamiento__intro__button">
          <div></div>
          <button v-if="!loadingForm" class="active" @click="sendForm()">
            Continuar
          </button>
          <button v-else disabled>Procesando ...</button>
        </div>
      </div>
    </div>
    <div
      v-if="showTooltipActive != ''"
      class="tooltip-background"
      @click="showTooltipActive = ''"
    ></div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { required, not } from "vuelidate/lib/validators";
import moment from "moment";

export default {
  data() {
    return {
      loading: true,
      submitted: false,
      section: "PROCEDURE",
      loadingForm: false,
      showTooltipActive: "",
      ProcedureInitDescription: null,
    };
  },
  computed: {
    ...mapState({
      Enums: (state) => state.neighregistration.Enums,
      ModelProcedure: (state) => state.manageVecino.ModelProcedure,
    }),
    ...mapGetters(["attachsRent"]),
    MinToDate() {
      if (this.ModelProcedure.ContractTypeId == 1)
        return moment(this.ModelProcedure.ContractDateFrom, "DD/MM/YYYY")
          .add(30, "days")
          .format("DD/MM/YYYY");
      else
        return moment(this.ModelProcedure.ContractDateFrom, "DD/MM/YYYY")
          .add(90, "days")
          .format("DD/MM/YYYY");
    },
    MaxToDate() {
      if (this.ModelProcedure.ContractTypeId == 1)
        return moment(this.ModelProcedure.ContractDateFrom, "DD/MM/YYYY")
          .add(90, "days")
          .format("DD/MM/YYYY");
      else return "";
    },
  },
  created() {
    // 72659e84-84e5-4133-aeac-8ffcb8787e4f
    const self = this;
    this.$store
      .dispatch("getProcedure", {
        ucode: this.$route.query.ucode,
      })
      .then(() => {
        self.$store
          .dispatch("getProcedureInitDescription", {
            ucode: this.$route.query.ucode,
          })
          .then((terms) => {
            self.ProcedureInitDescription = terms.ProcedureInitDescription;
          });

        self.$store.dispatch("getEnums");
        self.loading = false;

        if (self.$v.ModelProcedure.ProcedureType.$invalid) {
          self.$router.replace("/vecino/invalid/");
        } else {
          var element = document.querySelector(
            ".empadronamiento__intro__main__form__container-item .has-error"
          );
          if (element != null)
            element.scrollIntoView({ behavior: "smooth", block: "nearest" });
        }
      });
  },
  methods: {
    dateToIsInvalid() {
      let dateTo = moment(
        this.ModelProcedure.ContractDateTo,
        "DD/MM/YYYY"
      ).format("YYYY-MM-DD");
      let dateFrom30 = moment(
        this.ModelProcedure.ContractDateFrom,
        "DD/MM/YYYY"
      )
        .add(30, "days")
        .format("YYYY-MM-DD");
      let dateFrom90 = moment(
        this.ModelProcedure.ContractDateFrom,
        "DD/MM/YYYY"
      )
        .add(90, "days")
        .format("YYYY-MM-DD");

      if (this.ModelProcedure.ContractTypeId == 1) {
        return dateTo < dateFrom30 || dateTo > dateFrom90;
      } else {
        return dateTo < dateFrom90;
      }
    },
    getAttachPreviewURL(attach) {
      let attachId = null;
      attachId = this.ModelProcedure[this.getAttachModelPropName(attach)];
      if (attachId != null) {
        return `${
          process.env.VUE_APP_URL_API
        }/neighregistration/procedureattachment/preview/${attachId}`;
      }
      return "";
    },
    sendForm() {
      const self = this;
      self.submitted = true;
      self.$v.$touch();
      if (!self.isInvalidForm()) {
        self.loadingForm = true;
        self.ModelProcedure.ModelProcedure = Number(
          self.ModelProcedure.ModelProcedure
        );
        self.$store
          .dispatch("updateProcedure", {
            model: self.ModelProcedure,
          })
          .then(() => {
            self.loadingForm = false;
            self.$router.push(
              `/vecino/titularPropietario/0?ucode=${self.$route.query.ucode}`
            );
          });
      }
    },
    getAttachModelPropName({ Name }) {
      if (this.attachsRent.length === 0) return "";
      const returnValue = this.$store.getters.findAttachPropByName(
        Name,
        this.section
      );
      return returnValue;
    },
    getAttachValidator(attach) {
      if (this.attachsRent.length === 0) return false;
      const propName = this.getAttachModelPropName(attach);
      return this.$v.ModelProcedure[propName];
    },
    uploadFile({ file, attach, attachmentTypeId, modelProp }) {
      const self = this;
      const section = self.section;
      if (attach.Code === "ProcedureAttachment.LocationContract") {
        const validExtensions = ["pdf"];
        const fileExtension = file.name
          .split(".")
          .pop()
          .toLowerCase();

        if (!validExtensions.includes(fileExtension)) {
          window.mainApp.$store.dispatch(
            "addNotification",
            "Formato no permitido. La extension permitida es: pdf."
          );
          return;
        }
      }
      this.$store
        .dispatch("uploadFile", { file, attachmentTypeId, section })
        .then((res) => (self.ModelProcedure[modelProp] = res));
      self.getAttachValidator(attach, this.section).$touch();
    },
    clearFile({ modelProp }) {
      const self = this;
      self.ModelProcedure[modelProp] = 0;
    },
    isInvalidForm() {
      return (
        this.$v.ModelProcedure.ProcedureType.$invalid ||
        this.$v.ModelProcedure.ContractTypeId.$invalid ||
        this.$v.ModelProcedure.ContractDateFrom.$invalid ||
        this.$v.ModelProcedure.ContractDateTo.$invalid ||
        this.$v.ModelProcedure.LocationContract.$invalid
      );
    },
  },
  validations: {
    ModelProcedure: {
      ProcedureType: {
        not: not((model) => model === 1),
      },
      ContractTypeId: {
        required,
      },
      ContractDateFrom: {
        required,
      },
      ContractDateTo: {
        required,
      },
      LocationContract: {
        required,
        not: not((model) => model === 0),
      },
      PublicServiceBill: {
        //required,
        //not: not((model) => model === 0),
      },
    },
  },
};
</script>
